/* eslint-disable angular/file-name,angular/window-service */
angular.module('zc.zenclerkS')
  .factory('ZcsMakeshopApi', zcsMakeshopApi);

zcsMakeshopApi.$inject = ['Api'];
function zcsMakeshopApi(Api) {

  class ZcsMakeshopApi {

    static searchCoupons(project) {
      return Api.get(`/api/master/projects/${project.id}/makeshop/coupons`, project)
        .then(res => res.data.coupons);
    }
  }

  return ZcsMakeshopApi;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/makeshop_api.service.js